<template>
    <div class="user-info-form">
        <TotemToast ref="toast" />
        <TotemInputLabel isRequired>{{ $t("InfoForm.firstname") }}</TotemInputLabel>
        <TotemInput v-model="firstName" :fullWidth="true" :disabled="sending" @blur.native="$v.firstName.$touch()"/>
        <totem-form-finnish-label-error :field="$v.firstName" :label="$t('General.first_name')"/>

        <TotemInputLabel isRequired>{{ $t("InfoForm.lastname") }}</TotemInputLabel>
        <TotemInput v-model="lastName" :fullWidth="true" :disabled="sending" @blur.native="$v.lastName.$touch()"/>
        <totem-form-finnish-label-error :field="$v.lastName" :label="$t('General.last_name')"/>

        <form autocomplete="off">
            <TotemInputLabel>{{ $t("InfoForm.job_title") }}</TotemInputLabel>
            <TotemSelect v-model="jobTitle" :fullWidth="true" :value="jobTitle" :options="sortedJobTitles" :disabled="sending" :clearable="false" showSelectedOption/>
        </form>
        <div class="user-info-form__buttons">
            <TotemButton 
                v-on:click="updateUserInfo" 
                color="primary" 
                size="medium" 
                :label="$t('Info.update_userinfo')" 
            />
        </div>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    const { validName } = require('components/shared/global-forms/custom-validations.js')
    const { required } = require('vuelidate/lib/validators')
    import { mapGetters } from 'vuex'

    export default {
        props: {
            user: Object,
            sortedJobTitles: Array
        },
        mixins: [ validationMixin ],
        data () {
            return {
                firstName: '',
                lastName: '',
                jobTitle: {},
                sending: false
            }
        },
        computed: {
            ...mapGetters({
                userInfo: 'User/getUserInfo',
            }),
            compoundProperty () {
                this.user
                this.sortedJobTitles
                return Date.now()
            },
        },
        validations: {
            firstName: {
                required,
                validName
            },
            lastName: {
                required,
                validName
            }
        },
        watch: {
            compoundProperty () {
                this.firstName = this.user.firstName
                this.lastName = this.user.lastName
                this.jobTitle = this.sortedJobTitles.find(jobTitle => jobTitle.id === this.user.jobTitle)
            }
        },
        methods: {
            updateUserInfo (e) {
                this.error = null
                this.$v.$touch()
                if (this.$v.$invalid) {
                    e.preventDefault()
                } else {
                    this.sending = true
                    const userInfo = {
                        firstName: this.firstName,
                        lastName: this.lastName
                    }
                    if (this.jobTitle && this.jobTitle.id) {
                        userInfo.jobTitle = this.jobTitle.id
                    }
                    this.$emit('updateUserInfo', userInfo)
                }
            },
            onUserUpdated () {
                this.sending = false
                this.$refs.toast.show(this.$t('InfoForm.user_info_updated'))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .user-info-form {
        display: flex;
        flex-direction: column;

        &__header {
              font-size: 2rem;
              margin: 0 0 24px 0;
        }

        &__buttons {
            display: flex;
            flex-direction: column;
            margin: 15px 0 0;
        }

        .totem-button {
            display: block;
            margin: 0 0 20px;
            align-self: flex-start;
        }
    }
</style>
